export default __webpack_public_path__ + "static/media/p-logo.8691b112.svg";